import { useState } from 'react';
import { Icon } from '../../../layout/Icon.jsx';
import { toast } from '../../../shared/useToast.js';

// Note: backend wiring for manual override is a stub — will connect when
// `/api/gates/:id/override` lands in W5.
export function ManualOverrideModal({ gate, open, onClose }) {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (!open || !gate) return null;

  async function submit(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      // TODO: wire to backend once /api/gates/:id/override is available.
      toast.info(`تم تسجيل طلب تجاوز يدوي للبوابة ${gate.name}`);
      onClose?.();
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center"
      style={{ background: 'rgba(0,0,0,.45)' }}
    >
      <form
        className="card p-5 w-[420px] space-y-3"
        onClick={(e) => e.stopPropagation()}
        onSubmit={submit}
      >
        <div className="flex items-center justify-between">
          <h3 className="text-[15px] font-bold">تجاوز يدوي — {gate.name}</h3>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            <Icon name="x" size={14} />
          </button>
        </div>

        <div className="text-[12.5px] text-ink-2">
          سيُسجَّل هذا الإجراء في سجل التدقيق ويتطلّب صلاحية <code>gates.override</code>.
        </div>

        <div>
          <label className="block text-xs font-semibold text-ink-2 mb-1">سبب التجاوز</label>
          <textarea
            className="input"
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            required
          />
        </div>

        <div className="flex justify-end gap-2 pt-2">
          <button type="button" className="btn" onClick={onClose}>إلغاء</button>
          <button type="submit" className="btn btn-primary" disabled={submitting || !reason.trim()}>
            {submitting ? 'جاري...' : 'تأكيد التجاوز'}
          </button>
        </div>
      </form>
    </div>
  );
}
